import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

export const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    // Close mobile menu on route change
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileMenuOpen]);

    return (
        <nav className="landing-navbar">
            <div className="navbar-container">
                {/* Left: Logo */}
                <div className="navbar-brand">
                    <Link to="/">
                        <img src={logo} alt="CutIQ Logo" className="navbar-logo" />
                    </Link>
                </div>

                {/* Center: Navigation Links (Desktop) */}
                <div className="navbar-links">
                    <Link to="/features" className="navbar-link">
                        Features
                    </Link>
                    <Link to="/signup" className="navbar-link">
                        Pricing
                    </Link>
                    <Link to="/affiliates" className="navbar-link">Affiliates</Link>
                    <a
                        href="https://discord.gg/qtucaXb9EG"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="navbar-link navbar-link--discord"
                    >
                        <FaDiscord className="navbar-discord-icon" />
                        Community
                    </a>
                </div>

                {/* Right: CTA Buttons (Desktop) */}
                <div className="navbar-cta navbar-cta--desktop">
                    <Link to="/signin" className="navbar-signin">
                        Sign In
                    </Link>
                    <Link to="/signup" className="navbar-getstarted">
                        Get Started - It's Free
                    </Link>
                </div>

                {/* Mobile: Hamburger Button */}
                <button
                    className="navbar-hamburger"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
                >
                    {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div className="navbar-mobile-overlay" onClick={() => setMobileMenuOpen(false)}>
                    <div className="navbar-mobile-menu" onClick={(e) => e.stopPropagation()}>
                        {/* Close button */}
                        <button
                            className="navbar-mobile-close"
                            onClick={() => setMobileMenuOpen(false)}
                            aria-label="Close menu"
                        >
                            <X size={20} />
                        </button>

                        <div className="navbar-mobile-links">
                            <Link
                                to="/"
                                className={`navbar-mobile-link ${location.pathname === '/' ? 'active' : ''}`}
                            >
                                Home
                            </Link>
                            <Link
                                to="/features"
                                className={`navbar-mobile-link ${location.pathname === '/features' ? 'active' : ''}`}
                            >
                                Features
                            </Link>
                            <Link
                                to="/signup"
                                className={`navbar-mobile-link ${location.pathname === '/signup' ? 'active' : ''}`}
                            >
                                Pricing
                            </Link>
                            <Link
                                to="/affiliates"
                                className={`navbar-mobile-link ${location.pathname === '/affiliates' ? 'active' : ''}`}
                            >
                                Affiliates
                            </Link>
                            <a
                                href="https://discord.gg/qtucaXb9EG"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="navbar-mobile-link"
                            >
                                <FaDiscord className="navbar-discord-icon" />
                                Community
                            </a>
                        </div>
                        <div className="navbar-mobile-cta">
                            <Link to="/signin" className="navbar-signin navbar-signin--mobile">
                                Sign In
                            </Link>
                            <Link to="/signup" className="navbar-getstarted navbar-getstarted--mobile">
                                Get Started - It's Free
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};
